// src/app/state/reducers/pricing.reducer.ts
import { createReducer, on } from '@ngrx/store';
import * as PricingActions from '../actions/pricing.actions';
import { PricingState } from '../models/pricing.model';

export const initialState: PricingState = {
  pricingInfo: null
};

export const pricingReducer = createReducer(
  initialState,
  on(PricingActions.loadPricingPlansSuccess, (state, { pricingInfo }) => ({
    ...state,
    pricingInfo
  }))
);
